import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Login from './pages/login';
import AdminPanel from './pages/admin';
import AdminDashboard from './pages/admin-dashboard';
import ClientProjectView from './pages/client-project-view';
import ClientProjectViewAdmin from './pages/client-project-view-admin';
import NotFound from './pages/NotFound';
import ProfitCalculator from './pages/profit-calculator';
import TaxConfigurationSettings from './pages/tax-configuration-settings';
import ProfitCalculationHistory from './pages/profit-calculation-history';
import ReportsAndAnalyticsDashboard from './pages/reports-and-analytics-dashboard';
import ProjectTemplatesManagement from './pages/project-templates-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/profit-calculator" element={<ProfitCalculator />} />
          <Route path="/profit-calculation-history" element={<ProfitCalculationHistory />} />
          <Route path="/tax-configuration-settings" element={<TaxConfigurationSettings />} />
          <Route path="/reports-and-analytics-dashboard" element={<ReportsAndAnalyticsDashboard />} />
          <Route path="/project-templates-management" element={<ProjectTemplatesManagement />} />
          <Route path="/projeto" element={<ClientProjectView />} />
          <Route path="/client-project-view/:clientId" element={<ClientProjectViewAdmin />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;